module.exports = __webpack_public_path__ + "img/card-t1.055bf8eb.png";